export default [
    {
        path: "/Lookup/Index",
        name: "LookupIndex",
        component: () => import("@/components/Lookup/Index.vue"),
        meta: {
            name: "LookupIndex",
            menuTitle: "Lookup",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Lookup/Editor",
        name: "LookupEditor",
        component:  () => import("@/components/Lookup/Editor.vue"),
        meta: {
            name: "LookupEditor",
            menuTitle: "Lookup",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/User/Index",
        name: "UserIndex",
        component: () => import("@/components/User/Index.vue"),
        meta: {
            name: "UserIndex",
            menuTitle: "User",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/User/Editor",
        name: "UserEditor",
        component:  () => import("@/components/User/Editor.vue"),
        meta: {
            name: "UserEditor",
            menuTitle: "User",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Group/Index",
        name: "GroupIndex",
        component: () => import("@/components/Group/Index.vue"),
        meta: {
            name: "GroupIndex",
            menuTitle: "Group",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Group/Editor",
        name: "GroupEditor",
        component:  () => import("@/components/Group/Editor.vue"),
        meta: {
            name: "GroupEditor",
            menuTitle: "Group",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Company/Index",
        name: "CompanyIndex",
        component: () => import("@/components/Company/Index.vue"),
        meta: {
            name: "CompanyIndex",
            menuTitle: "Company",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Company/Editor",
        name: "CompanyEditor",
        component:  () => import("@/components/Company/Editor.vue"),
        meta: {
            name: "CompanyEditor",
            menuTitle: "Company",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/ReleaseMatrix/Index",
        name: "ReleaseMatrixIndex",
        component: () => import("@/components/ReleaseMatrix/Index.vue"),
        meta: {
            name: "ReleaseMatrixIndex",
            menuTitle: "ReleaseMatrix",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/ReleaseMatrix/Editor",
        name: "ReleaseMatrixEditor",
        component:  () => import("@/components/ReleaseMatrix/Editor.vue"),
        meta: {
            name: "ReleaseMatrixEditor",
            menuTitle: "ReleaseMatrix",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Contractor/Index",
        name: "ContractorIndex",
        component: () => import("@/components/Contractor/Index.vue"),
        meta: {
            name: "ContractorIndex",
            menuTitle: "Contractor",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Contractor/Editor",
        name: "ContractorEditor",
        component:  () => import("@/components/Contractor/Editor.vue"),
        meta: {
            name: "ContractorEditor",
            menuTitle: "Contractor",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Location/Index",
        name: "LocationIndex",
        component: () => import("@/components/Location/Index.vue"),
        meta: {
            name: "LocationIndex",
            menuTitle: "Location",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Location/Editor",
        name: "LocationEditor",
        component:  () => import("@/components/Location/Editor.vue"),
        meta: {
            name: "LocationEditor",
            menuTitle: "Location",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/APILog/Index",
        name: "APILogIndex",
        component: () => import("@/components/APILog/Index.vue"),
        meta: {
            name: "APILogIndex",
            menuTitle: "APILog",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/APILog/ShowList",
        name: "APILogShowList",
        component: () => import("@/components/APILog/ShowList.vue"),
        meta: {
            name: "APILogShowList",
            menuTitle: "APILog",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/VersionLog/Index",
        name: "VersionLogIndex",
        component: () => import("@/components/VersionLog/Index.vue"),
        meta: {
            name: "VersionLogIndex",
            menuTitle: "VersionLog",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/VersionLog/Editor",
        name: "VersionLogEditor",
        component:  () => import("@/components/VersionLog/Editor.vue"),
        meta: {
            name: "VersionLogEditor",
            menuTitle: "VersionLog",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Documentation/Index",
        name: "DocumentationIndex",
        component: () => import("@/components/Documentation/Index.vue"),
        meta: {
            name: "DocumentationIndex",
            menuTitle: "Documentation",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Documentation/Editor",
        name: "DocumentationEditor",
        component:  () => import("@/components/Documentation/Editor.vue"),
        meta: {
            name: "DocumentationEditor",
            menuTitle: "Documentation",
            requiresAuth: true
        },
        props: true
    },

    {
        path: "/GeneralInformation/Documentation",
        name: "GeneralInformationDocumentation",
        component:  () => import("@/components/GeneralInformation/Documentation.vue"),
        meta: {
            name: "GeneralInformationDocumentation",
            menuTitle: "GeneralInformation",
            requiresAuth: false
        },
        props: false
    },
    {
        path: "/GeneralInformation/VersionLog",
        name: "GeneralInformationVersionLog",
        component:  () => import("@/components/GeneralInformation/VersionLog.vue"),
        meta: {
            name: "GeneralInformationVersionLog",
            menuTitle: "GeneralInformation",
            requiresAuth: false
        },
        props: false
    },
]   